<svg id='printSectionId' style='padding-left:6%;padding-top:5%;' viewBox='0 0 410 240'></svg>